module.exports = __webpack_public_path__ + "static/sinan-cakir-d8cd847182dbe0580e55b5129117e99c.jpg";